import { ContextualActionType } from './contextual-action-type';

export class ContextualMenuSelectEvent {
    constructor(
        public actionType: ContextualActionType,
        public context: any = null
    ) {}
}
